import {memo} from "react";
import {Button, ButtonProps} from "../../../ui/button";
import T from "platformed-components/i18n/T";

export const ClearFiltersButton = memo((props: ButtonProps) => {
  return (
    <Button size="xs" colorPalette="blue" variant="ghost" {...props}>
      <T keyName="c.Clear" />
    </Button>
  );
});
